export function getCallerName() {
	let callerName = '';
 	try {
    	throw new Error();
  	}
  	catch (e) {
	    try {
	    	callerName = e.stack.split('at ')[3].split(' ')[0];
	    } 
	    catch (e) {
	    	
	    }
   }
   return callerName;	
}
